module.exports = __webpack_public_path__ + "static/img/Productlist.431e4ca5.png";